import { useState } from "react";
import { toast } from "react-toastify";

import { useAuth } from "GlobalProvider";
import { getErrorMessage } from "helpers";

import { login, LoginRequest } from "services/auth";

export const useLoginPage = () => {
  const { loginUser } = useAuth();

  const [loginState, setLoginState] = useState<LoginRequest>({
    email: "",
    password: "",
  });

  const onInputChange = (e: any) => {
    setLoginState((old) => ({ ...old, [e.target.name]: e.target.value || "" }));
  };

  const signIn = async (e: any) => {
    e.preventDefault();
    try {
      const resp = await login(loginState);
      loginUser(resp.token);
      toast.success("Successfully logged in.");
    } catch (e) {
      toast.error(getErrorMessage(e));
      console.error(e);
    }
  };

  return { loginState, onInputChange, signIn };
};
